$(document).ready(function(){
   $('.accord1 li p').click(function(){
    $(this).next(".accord-content").slideToggle();
      $(this).closest("li").siblings().find('.accord-content').slideUp();
  });

  // Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

  $(".search--bar .test input.boost-pfs-search-box").attr("placeholder", "What are you looking for");  

  $('.home-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3
  });

  $('#more-details').click(function(){
      $('.emi-chart').show();
    });
    $('.emi-chart span.action_button').click(function(){
      $('.emi-chart').hide(); 
    });

    $('#blog-slider').slick({
     slidesToShow: 3,
     slidesToScroll: 1,
     adaptiveHeight: true,
     infinite: true,
     arrows: true,
     responsive: [
       {
         breakpoint: 768,
         settings: {
           arrows: false,
           centerMode: true,
           centerPadding: '40px',
           slidesToShow: 2,
           slidesToScroll: 1,
         }
       },
       {
         breakpoint: 480,
         settings: {
           arrows: false,
           centerMode: true,
           centerPadding: '40px',
           slidesToShow: 1,
           slidesToScroll: 1,
         }
       }
     ]
   });
  
   $('.home-slider2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
     
      fade: false,
      adaptiveHeight: true,
      useTransform: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
   });
/****** home slider****/
  
   $('.home-slider2-nav').on('init', function(event, slick) {
          $('.home-slider2-nav .slick-slide.slick-current').addClass('is-active');
      }).slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: false,
          focusOnSelect: false,
          infinite: false,
          nav:false,
     	arrow:false,
          responsive: [{
              breakpoint: 1024,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
              }
          }, {
              breakpoint: 640,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
              }
          }, {
              breakpoint: 420,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
          }
          }]
      });

   $('.home-slider2').on('afterChange', function(event, slick, currentSlide) {
      $('.home-slider2-nav').slick('slickGoTo', currentSlide);
      var currrentNavSlideElem = '.home-slider2-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
      $('.home-slider2-nav .slick-slide.is-active').removeClass('is-active');
      $(currrentNavSlideElem).addClass('is-active');
   });

   $('.home-slider2-nav').on('click', '.slick-slide', function(event) {
      event.preventDefault();
      var goToSingleSlide = $(this).data('slick-index');

      $('.home-slider2').slick('slickGoTo', goToSingleSlide);
   });
  /***account***/
   
  $(".ul.sideber").click(function () {
        if(!$(this).hasClass('active'))
        {
            $(".li.active").removeClass("active");
            $(this).addClass("active");        
        }
    });
  
   $('.slider-offer').slick({
     breakpoint: 600,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      adaptiveHeight: true,
      infinite: false,
      useTransform: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
   });
 
  
   $('.slider-custom').slick({
      slidesToShow: 3,
     slidesToScroll: 1,
     adaptiveHeight: true,
     infinite: true,
     arrows: true,
     responsive: [
       {
         breakpoint: 768,
         settings: {
           arrows: false,
           centerMode: true,
           centerPadding: '40px',
           slidesToShow: 2
         }
       },
       {
         breakpoint: 480,
         settings: {
           arrows: false,
           centerMode: true,
           centerPadding: '40px',
           slidesToShow: 1
         }
       }
     ]
   });
  
  $('#product_re1').slick({
      slidesToShow: 2,
     slidesToScroll: 1,
     adaptiveHeight: true,
     infinite: true,
     arrows: true,
     responsive: [
       {
         breakpoint: 768,
         settings: {
           arrows: false,
           centerMode: true,
           centerPadding: '40px',
           slidesToShow: 2
         }
       },
       {
         breakpoint: 480,
         settings: {
           arrows: false,
           centerMode: true,
           centerPadding: '40px',
           slidesToShow: 1
         }
       }
     ]
   });
  

  $("#copyUsingJquery").click(function() {
    copyUsingJquery("#copyTarget");
  });
 

  function copyUsingJquery(element_id) {
    $('#copyTarget').attr("contenteditable", true)
      .select()
      .on("focus", function() {
        document.execCommand('selectAll', false, null)
      })
      .focus()
    document.execCommand("Copy");
    $('#copyTarget').removeAttr("contenteditable");
     //alert("Copy Promo Code");
  }

   $("button.shopify-payment-button__button").text('Buy Now');
});



$(document).ready(function(){
var mac=0;
  if(navigator.userAgent.indexOf('Mac') > 0){ //alert(navigator.userAgent.indexOf('Mac'))
        mac=1;
    }else{
        mac=0;
    }

if(1==mac){
    //document.body.className+='mac-os';
    //document.getElementsByTagName('body')[0].className+='mac-os';
  $("body").addClass("mac-os"); 
}else{
    //document.body.className+='win-os';
    //document.getElementsByTagName('body').className+='win-os';
    //$('body').addClass('mac-os');
    //$("body.className").addClass('win-os');
    //document.body.className += " " + 'win-os';
    $("body").addClass('win-os');
}
});
      


  $(window).scroll(function(){
    var winTop = $(window).scrollTop();
    if(winTop >= 30){
      $(".header--root").addClass("sticky");
    }else{
      $(".header--root").removeClass("sticky");
    }//if-else
  });//win func.


$(window).scroll(function(){
    var winTop = $(window).scrollTop();
    if(winTop >= 30){
      $(".fixed-mobile-bottom-bar").addClass("sticky-mobile");
    }else{
      $(".fixed-mobile-bottom-bar").removeClass("sticky-mobile");
    }//if-else
  });//win func.


// $(document).ready(function(){
//     //alert("Test ");
//     $(".product-buy-buttons--cta.add-to-cart").click(function(e){
//       $(".template--product.win-os.jdgm-buyer-badge--removed").addClass("product_aic");
//       e.stopPropagation();
//     });

//     $(".close_icon").click(function(e){
//       $(".template--product.win-os.jdgm-buyer-badge--removed").removeClass("product_aic");
//       e.stopPropagation();
//     });
     
//   });

//   $(".product_aic").click(function(e){
//     e.stopPropagation();
//   });

//   $(document).click(function(e){
//     $(".template--product.win-os.jdgm-buyer-badge--removed").removeClass("product_aic");
//     e.stopPropagation();
//   });




  //New Side Cart Code Start here 
// JavaScript code
document.addEventListener('DOMContentLoaded', function() {
  var addToCartButton = document.getElementById('add-to-cart-button');
  var pdpAddToCartButtons = document.querySelectorAll('.but_it_with.pdp_btn');
  var sideCart = document.querySelector('.mypositionSidebar');
  var cartItemsContainer = document.querySelector('.cart_items');
  var emptyCartMessage = document.querySelector('.js-empty-cart__message');
  var checkOutNewButton = document.querySelector('.checkout_new-btn_side');

  updateCartQty();

  addToCartButton.addEventListener('click', function() {
      var productId = this.getAttribute('data-product-id');
      addToCart(productId);
  });

  pdpAddToCartButtons.forEach(function(button) {
      button.addEventListener('click', function() {
          var productId = this.getAttribute('data-product-id');
          addToCart(productId);
      });
  });

  function addToCart(productId) {
      let myCustomQtyInput = document.querySelector('.quantity-input').value;
      fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  id: productId,
                  quantity: myCustomQtyInput
              }),
          })
          .then(response => response.json())
          .then(data => {
              refreshCart();
          })
          .catch(error => {
              console.error('Error adding to cart:', error);
          });
  }

  function refreshCart() {
      fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
              updateCartItems(data.items, () => {
                  document.querySelector('.cart_count').textContent = data.item_count;
                  document.querySelector('.cart-link__bubble').textContent = data.item_count;

                  sideCart.classList.add('active_cart');
                  mysidebarCartBg.style.display = 'block';
                  document.body.style.overflow = 'hidden';
                  cartTotalPrice(data);
              });
          })
          .catch(error => {
              console.error('Error updating cart:', error);
          });
  }

  function updateCartItems(items, callback) {
      cartItemsContainer.innerHTML = '';
      let itemsProcessed = 0;

      items.forEach(item => {
          fetch(`/products/${item.handle}.json`)
              .then(response => response.json())
              .then(productJson => {
                  var productItemVariant = productJson.product.variants;
                  var myComapareAtPrice = 0;
                  productItemVariant.forEach(productVariant => {
                      if (item.variant_id == productVariant.id) {
                          myComapareAtPrice = parseFloat(productVariant.compare_at_price);
                          var itemPrice = parseFloat(item.price / 100);

                          var itemElement = `
                              <li class="cart_item_newcart">
                                  ${item.image ? `<div class="cart_image">
                                      <img src="${item.image}" alt="${item.title}" />
                                  </div>` : ''}
                                  <div class="cart_item__title">
                                      <div class="item__title__cont">
                                          <div class="item_title">
                                              <span class="cart_pr-title">${item.product_title}</span>
                                              ${item.variant_title && item.variant_title !== 'Default Title' ? 
                                                `<div class="variant__title">${item.variant_title}</div>` : 
                                                '<div class="variant__title"></div>'}
                                          </div>
                                      </div>
                                      <div class="qty__price__sideCart">
                                          <div class="quantity">
                                              <button type="button" class="quantity__minus" data-id="${item.key}">-</button>
                                              <input type="text" class="quantity__input" value="${item.quantity}" readonly>
                                              <button type="button" class="quantity__plus" data-id="${item.key}">+</button>
                                          </div>
                                          <strong class="price">
                                          <span class="money current_price">Rs. ${(itemPrice).toLocaleString('en-IN')}</span>
                                          ${myComapareAtPrice > itemPrice ? `<span class="money was_price"><s>Rs. ${(myComapareAtPrice).toLocaleString('en-IN')}</s></span>` : ''}
                                          </strong>
                                      </div>
                                  </div>
                                  <div class="dlt_vish-svg">
                                      <div class="remove_itm" onclick="removeItem(this)">
                                          <svg width="36" height="36" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2315_14859)">
                                      <rect width="30" height="30" rx="15" fill="white"/>
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1525 9.99466C12.1525 9.78908 12.3192 9.62246 12.5247 9.62246H15.5364C15.742 9.62246 15.9086 9.78908 15.9086 9.99466V10.3331H12.1525V9.99466ZM10.9343 10.3331V9.99466C10.9343 9.1163 11.6464 8.40427 12.5247 8.40427H15.5364C16.4147 8.40427 17.1268 9.1163 17.1268 9.99466V10.3331H18.6495C19.5092 10.3331 20.2061 11.0299 20.2061 11.8896V12.1265C20.2061 12.7958 19.7837 13.3664 19.1909 13.5864V21.3645C19.1909 22.4858 18.2819 23.3948 17.1606 23.3948H10.9005C9.77915 23.3948 8.87013 22.4858 8.87013 21.3645V13.5864C8.27739 13.3664 7.85498 12.7958 7.85498 12.1265V11.8896C7.85498 11.0299 8.55188 10.3331 9.41156 10.3331H10.9343ZM10.0884 13.6831V21.3645C10.0884 21.813 10.4519 22.1766 10.9005 22.1766H17.1606C17.6091 22.1766 17.9728 21.813 17.9728 21.3645V13.6831H10.0884ZM9.41156 12.4649C9.22467 12.4649 9.07317 12.3134 9.07317 12.1265V11.8896C9.07317 11.7027 9.22467 11.5512 9.41156 11.5512H18.6495C18.8364 11.5512 18.9879 11.7027 18.9879 11.8896V12.1265C18.9879 12.3134 18.8364 12.4649 18.6495 12.4649H9.41156ZM12.3894 15.3074C12.7258 15.3074 12.9985 15.5801 12.9985 15.9164V20.0109C12.9985 20.3473 12.7258 20.62 12.3894 20.62C12.053 20.62 11.7803 20.3473 11.7803 20.0109V15.9164C11.7803 15.5801 12.053 15.3074 12.3894 15.3074ZM15.6717 15.3074C16.0081 15.3074 16.2808 15.5801 16.2808 15.9164V20.0109C16.2808 20.3473 16.0081 20.62 15.6717 20.62C15.3353 20.62 15.0626 20.3473 15.0626 20.0109V15.9164C15.0626 15.5801 15.3353 15.3074 15.6717 15.3074Z" fill="#313283"/>
                                      <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71574 23.2843 0 15 0C6.71574 0 0 6.71574 0 15C0 15.1717 0.00288594 15.3428 0.00861195 15.5131C0.269608 8.01543 6.42999 2.01735 13.9913 2.01735C21.7185 2.01735 27.9826 8.2815 27.9826 16.0087C27.9826 23.57 21.9846 29.7304 14.4869 29.9914C14.6572 29.9971 14.8283 30 15 30Z" fill="#00AEEF"/>
                                      </g>
                                      <defs>
                                      <clipPath id="clip0_2315_14859">
                                      <rect width="30" height="30" rx="15" fill="white"/>
                                      </clipPath>
                                      </defs>
                                      </svg>
                                      </div>
                                      <div class="ivish">
                                          <a href="javascript:void(0)" class="iWishAddColl iwishcheck cartPage-wish"
                                              data-product="${item.product_id}" data-variant="${item.variant_id}">
                                              <svg width="36px" height="36px" viewBox="0 0 922 922" xmlns="http://www.w3.org/2000/svg"><path
                                      d="M461 922C715.603 922 922 715.603 922 461C922 206.397 715.603 0 461 0C206.397 0 0 206.397 0 461C0 466.278 0.0886945 471.535 0.264674 476.77C8.28594 246.341 197.615 62 430 62C667.482 62 860 254.518 860 492C860 724.385 675.659 913.714 445.23 921.735C450.465 921.911 455.722 922 461 922Z"
                                      fill="var(--bg_color2)" />
                                      <path
                                      d="M613.209 350.435C590.353 327.578 559.968 315 527.644 315C495.315 315 464.927 327.578 442.063 350.435L430.8 361.701L419.537 350.435C396.68 327.578 366.285 315 333.963 315C301.642 315 271.245 327.578 248.39 350.435C201.203 397.627 201.203 474.409 248.39 521.582L417.473 690.666C420.238 693.441 423.68 695.14 427.275 695.794C428.481 696.032 429.694 696.143 430.909 696.143C435.692 696.143 440.483 694.318 444.126 690.666L613.21 521.582C660.399 474.409 660.399 397.627 613.209 350.435ZM586.774 495.149L430.801 651.124L274.825 495.149C242.215 462.544 242.215 409.493 274.825 376.871C290.62 361.077 311.629 352.391 333.963 352.391C356.299 352.391 377.302 361.077 393.092 376.871L417.583 401.369C424.603 408.379 437.006 408.379 444.025 401.369L468.507 376.871C484.298 361.077 505.302 352.391 527.645 352.391C549.981 352.391 570.983 361.077 586.774 376.871C619.387 409.493 619.387 462.542 586.774 495.149Z"
                                      fill="var(--bg_color1)" /></svg>
                                          </a>
                                      </div>
                                  </div>
                              </li>
                          `;

                          cartItemsContainer.insertAdjacentHTML('beforeend', itemElement);
                          updateCartQty();;
                          toggleCartDisplay();
                      }
                  });

                  itemsProcessed++;
                  if (itemsProcessed === items.length) {
                      callback();
                  }
              })
              .catch(error => {
                  console.error('Error fetching product data:', error);
              });
      });
  }

  function toggleCartDisplay() {
      const form = document.querySelector('.js-cart_content__form');
      const cartItems = document.querySelector('.cart_items.js-cart_items.clearfix');
      const cartItemNewCart = cartItems.querySelector('.cart_item_newcart');

      if (cartItemNewCart) {
          form.style.display = 'block';
          emptyCartMessage.style.display = 'none';
      } else {
          form.style.display = 'none';
          emptyCartMessage.style.display = 'block';
      }
  }

//   mysidebarCartBg.addEventListener('click', function() {
//       mysideCartClose();
//   });

//   closebtn_sidecart.addEventListener('click', function() {
//     mysideCartCloseX();
//   });

//   closebtn_sidecart_btn.addEventListener('click', function() {
//     mysideCartCloseBtn();
//   });



//   function mysideCartClose() {
//       sideCart.classList.remove('active_cart');
//       document.getElementById('mysidebarCartBg').style.display = 'none';
//       document.body.style.overflow = '';
//   }

//   function mysideCartCloseX() {
//     sideCart.classList.remove('active_cart');
//     document.getElementById('mysidebarCartBg').style.display = 'none';
//     document.body.style.overflow = '';
// }

// function mysideCartCloseBtn() {
//   sideCart.classList.remove('active_cart');
//   document.getElementById('mysidebarCartBg').style.display = 'none';
//   document.body.style.overflow = '';
// }

//   document.getElementById('mysidebarCartBg').addEventListener('click', function() {
//       mysideCartClose();
//   });

//   document.getElementById('closebtn_sidecart').addEventListener('click', function() {
//     mysideCartCloseX();
//   });

// document.getElementById('closebtn_sidecart_btn').addEventListener('click', function() {
//   mysideCartCloseBtn();
//   });

  function updateCartQty() {
      document.querySelectorAll('.quantity__plus').forEach(button => {
          button.addEventListener('click', function(event) {
              event.preventDefault();
              let input = this.previousElementSibling;
              let quantity = parseInt(input.value) + 1;
              updateCart(this.dataset.id, quantity, input);
          });
      });

      document.querySelectorAll('.quantity__minus').forEach(button => {
          button.addEventListener('click', function(event) {
              event.preventDefault();
              let input = this.nextElementSibling;
              let quantity = parseInt(input.value) - 1;
              updateCart(this.dataset.id, quantity, input);
          });
      });

      document.querySelectorAll('.remove_itm').forEach(button => {
          button.addEventListener('click', function(event) {
              event.preventDefault();
              let cartItem = this.closest('.cart_item_newcart');
              let input = cartItem.querySelector('.quantity__input');
              let itemId = cartItem.querySelector('.quantity__minus').getAttribute('data-id');
              let quantity = 0;
              updateCart(itemId, quantity, input);
          });
      });
  }

  function updateCart(itemId, quantity, inputElement) {
      if (quantity < 0) quantity = 0;

      fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                  id: itemId,
                  quantity: quantity
              })
          })
          .then(response => response.json())
          .then(data => {
              let updatedItem = data.items.find(item => item.key === itemId);
              if (updatedItem) {
                  inputElement.value = updatedItem.quantity;
              } else if (quantity === 0) {
                  inputElement.value = 0;
                  let productElement = inputElement.closest('.cart_item_newcart');
                  if (productElement) {
                      productElement.remove();
                  }
              }

              document.querySelector('.cart_count').textContent = data.item_count;
              document.querySelector('.cart-link__bubble').textContent = data.item_count;

              cartTotalPrice(data);
              toggleCartDisplay();
          })
          .catch(error => console.error('Error updating cart:', error));
  }

  function cartTotalPrice(data) {
      const totalPriceElement = document.querySelector('.cart--total--price_newcart.money');
      if (totalPriceElement) {
          let totalPrice = data.total_price / 100;
          totalPriceElement.textContent = 'Rs. ' + Math.round(totalPrice).toLocaleString('en-IN');
      }
  }

  toggleCartDisplay();
});


document.getElementById('cartLink').addEventListener('click', function(event) {
  event.preventDefault();
  sideCart.classList.add('active_cart');
  document.getElementById('mysidebarCartBg').style.display = 'block';
  document.body.style.overflow = 'hidden';
});

 function mysideCartClose() {
  sideCart.classList.remove('active_cart');
  document.getElementById('mysidebarCartBg').style.display = 'none';
  document.body.style.overflow = '';
 }
 
 // Event listener to hide the side cart and background when background is clicked
 document.getElementById('mysidebarCartBg').addEventListener('click', function() {
  mysideCartClose();
 });








function addToCartPdp(button) {
  var loadingSpinner = button.querySelector('.product-buy-buttons--spinner_pdp');
  var buttonText = button.querySelector('#buttonTextPdp');

  loadingSpinner.style.display = 'inline-block';
  buttonText.style.display = 'none';

  setTimeout(function() {
    loadingSpinner.style.display = 'none';
    buttonText.style.display = 'inline';
  }, 3000);

  console.log("Item added to cart (PDP)!");
}

function addToCartFooter(button) {
  var loadingSpinner = button.querySelector('.product-buy-buttons--spinner_footer');
  var buttonText = button.querySelector('#buttonTextFooter');

  loadingSpinner.style.display = 'inline-block';
  buttonText.style.display = 'none';

  setTimeout(function() {
    loadingSpinner.style.display = 'none';
    buttonText.style.display = 'inline';
  }, 3000);

  console.log("Item added to cart (Footer)!");
}